var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex w-full" },
    [
      _c(
        "Tooltip",
        {
          attrs: {
            title: _vm.tooltipTitle,
            variant: _vm.TooltipVariants.DARK,
            tooltipClasses: "w-60",
            placement: "top",
          },
        },
        [
          _vm.colorCode
            ? _c("ColorCodeTriangle", {
                attrs: {
                  variant: _vm.TooltipVariants.DARK,
                  tooltipClasses: "w-60",
                  colorCode: _vm.colorCode,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "flex self-center items-center w-full",
          class: _vm.avatarsPadding,
        },
        [
          _c("SchedulerItemAvatar", {
            attrs: { title: _vm.itemName, avatar: _vm.avatar },
          }),
          _c(
            "div",
            {
              staticClass:
                "flex flex-col truncate ml-2 text-white w-40 flex-grow text-sm font-semibold",
            },
            [
              _vm.isCurrentUserManager
                ? _c("span", [_vm._v(_vm._s(_vm.itemName))])
                : _c("span", { staticClass: "truncate" }, [
                    _c("span", { staticClass: "text-sm form-semibold" }, [
                      _vm._v("Manager: "),
                    ]),
                    _c("span", { staticClass: "font-bold" }, [
                      _vm._v(_vm._s(_vm.itemName)),
                    ]),
                  ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }